import { render } from "./medical-details-modal.vue?vue&type=template&id=dbee6eac"
import script from "./medical-details-modal.vue?vue&type=script&lang=js"
export * from "./medical-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__